import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

export const SignupSchema = (t: TFunction) =>
  Yup.object().shape({
    firstName: Yup.string().required(t('common:requiredField')),
    lastName: Yup.string().required(t('common:requiredField')),
    contactPhone: Yup.string().required(t('common:requiredField')),
    email: Yup.string()
      .email(t('common:signup.form.email.errors.invalid'))
      .required(t('common:requiredField')),
  });
